export const RebuildBlockLogo = ({ className = 'w-full h-auto', scaleText = 1, fontWeight = '400' }) => {
  const textSize = 18 * scaleText;

  return (
    <svg
      viewBox="0 0 300 170"
      role="img"
      aria-label="RE BUILD ME logo"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="10" y="12" width="88" height="42" rx="6" fill="var(--theme-primary)" />
      <text x="54" y="39" textAnchor="middle" fill="var(--theme-logo-text, #F9F9FF)" fontSize={textSize} fontFamily="var(--font-heading)" fontWeight={fontWeight}>RE</text>

      <rect x="10" y="64" width="48" height="42" rx="6" fill="var(--theme-primary)" />
      <text x="34" y="91" textAnchor="middle" fill="var(--theme-logo-text, #F9F9FF)" fontSize={textSize} fontFamily="var(--font-heading)" fontWeight={fontWeight}>B</text>

      <rect x="66" y="64" width="48" height="42" rx="6" fill="var(--theme-primary)" />
      <text x="90" y="91" textAnchor="middle" fill="var(--theme-logo-text, #F9F9FF)" fontSize={textSize} fontFamily="var(--font-heading)" fontWeight={fontWeight}>U</text>

      <rect x="122" y="64" width="48" height="42" rx="6" fill="var(--theme-primary)" />
      <text x="146" y="91" textAnchor="middle" fill="var(--theme-logo-text, #F9F9FF)" fontSize={textSize} fontFamily="var(--font-heading)" fontWeight={fontWeight}>I</text>

      <rect x="178" y="64" width="48" height="42" rx="6" fill="var(--theme-primary)" />
      <text x="202" y="91" textAnchor="middle" fill="var(--theme-logo-text, #F9F9FF)" fontSize={textSize} fontFamily="var(--font-heading)" fontWeight={fontWeight}>L</text>

      <rect x="234" y="64" width="48" height="42" rx="6" fill="var(--theme-primary)" />
      <text x="258" y="91" textAnchor="middle" fill="var(--theme-logo-text, #F9F9FF)" fontSize={textSize} fontFamily="var(--font-heading)" fontWeight={fontWeight}>D</text>

      <rect x="194" y="116" width="88" height="42" rx="6" fill="var(--theme-primary)" />
      <text x="238" y="143" textAnchor="middle" fill="var(--theme-logo-text, #F9F9FF)" fontSize={textSize} fontFamily="var(--font-heading)" fontWeight={fontWeight}>ME</text>
    </svg>
  );
};

export default RebuildBlockLogo;
